import React from 'react';
import Modal from 'react-modal';
import modalUtils from '../../qti/utils/ModalUtils';
import modalStyles from '../../styles/generic/modal.scss';

import { t } from '../../services/i18nService';
import hardwareConstants from '../../constants/HardwareConstants';

const SecondScreenDetectedModal = () => {
    return (<Modal
        ariaHideApp={false}
        isOpen
        role="dialog"
        shouldCloseOnEsc={false}
        shouldCloseOnOverlayClick={false}
        style={modalUtils.confirmationModalStyles}
        tabindex="0"
        aria={{ describedby: 'secondScreenDetectedModalContent' }}
    >
        <div className={modalStyles.modalContentWrapper} id="secondScreenDetectedModalContent">
            <h2 className={modalStyles.modalTitle}>
                { t('hardwareDetection.secondScreen.modal.title') }
            </h2>

            <div className={modalStyles.modalContent}>
                <div className={modalStyles.modalContentPart}>
                    <p>
                        { t('hardwareDetection.secondScreen.modal.description', { seconds: hardwareConstants.exitTimeoutOnSecondDisplayDetected }) }
                    </p>
                    <p>
                        { t('hardwareDetection.secondScreen.modal.action') }
                    </p>
                </div>

            </div>
        </div>
    </Modal>);
};

export default SecondScreenDetectedModal;
